var exports = {
  "C$": "PremiumSectionNav.module__nav___ZFlWNl",
  "nf": "PremiumSectionNav.module__link___ZFlWNl",
  "zm": "PremiumSectionNav.module__linkActive___ZFlWNl",
};

module.exports = exports;
